import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

///////////////////////////////////////////////////////////////////
// User strollers load

export const USER_STROLLERS_FETCH_TRIGGER = 'USER_STROLLERS_FETCH_TRIGGER';
export interface UserStrollersFetchTriggerAction {
    readonly type: typeof USER_STROLLERS_FETCH_TRIGGER;
    readonly userId: number;
}
export const USER_STROLLERS_FETCH_REQUEST = 'USER_STROLLERS_FETCH_REQUEST';
export interface UserStrollersFetchRequestAction extends APIRequestAction {
    readonly type: typeof USER_STROLLERS_FETCH_REQUEST;
    readonly userId: number;
}
export interface UserStrollersFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { strollers: number[]; reviews: number[] };
}
export const USER_STROLLERS_FETCH_SUCCESS = 'USER_STROLLERS_FETCH_SUCCESS';
export interface UserStrollersFetchSuccessAction extends APISuccessAction<UserStrollersFetchNormalizedResponse> {
    readonly type: typeof USER_STROLLERS_FETCH_SUCCESS;
    readonly userId: number;
}
export const USER_STROLLERS_FETCH_FAILURE = 'USER_STROLLERS_FETCH_FAILURE';
export interface UserStrollersFetchFailureAction extends APIFailureAction {
    readonly type: typeof USER_STROLLERS_FETCH_FAILURE;
    readonly userId: number;
}

export const userStrollersFetchTrigger =
    (userId: number): UserStrollersFetchTriggerAction => ({
        type: USER_STROLLERS_FETCH_TRIGGER, userId,
    });
export const userStrollersFetchApi = {
    request: (userId: number): UserStrollersFetchRequestAction => ({
        type: USER_STROLLERS_FETCH_REQUEST, userId,
    }),
    success: (userId: number, response: UserStrollersFetchNormalizedResponse): UserStrollersFetchSuccessAction => ({
        type: USER_STROLLERS_FETCH_SUCCESS, userId, response,
    }),
    failure: (userId: number, error: any): UserStrollersFetchFailureAction => ({
        type: USER_STROLLERS_FETCH_FAILURE, userId, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Create connection between user and stroller

export interface UserStrollerConnectionCreateAction extends Action {
    readonly strollerId: number;
    readonly userId: number;
}

export const USER_STROLLER_CONNECTION_CREATE_TRIGGER = 'USER_STROLLER_CONNECTION_CREATE_TRIGGER';
export interface UserStrollerConnectionCreateTriggerAction extends UserStrollerConnectionCreateAction, Action {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_TRIGGER;
}
export const USER_STROLLER_CONNECTION_CREATE_REQUEST = 'USER_STROLLER_CONNECTION_CREATE_REQUEST';
export interface UserStrollerConnectionCreateRequestAction extends UserStrollerConnectionCreateAction, APIRequestAction {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_REQUEST;
}
export interface UserStrollerConnectionCreateNormalizedResponse extends NormalizedResponse {
    readonly result: { stroller: number };
}
export const USER_STROLLER_CONNECTION_CREATE_SUCCESS = 'USER_STROLLER_CONNECTION_CREATE_SUCCESS';
export interface UserStrollerConnectionCreateSuccessAction extends UserStrollerConnectionCreateAction, APISuccessAction<UserStrollerConnectionCreateNormalizedResponse> {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_SUCCESS;
}
export const USER_STROLLER_CONNECTION_CREATE_FAILURE = 'USER_STROLLER_CONNECTION_CREATE_FAILURE';
export interface UserStrollerConnectionCreateFailureAction extends UserStrollerConnectionCreateAction, APIFailureAction {
    readonly type: typeof USER_STROLLER_CONNECTION_CREATE_FAILURE;
}

export const userStrollersConnectionCreateTrigger =
    (strollerId: number, userId: number): UserStrollerConnectionCreateTriggerAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_TRIGGER, strollerId, userId,
    });
export const userStrollersConnectionCreateActions = {
    request: (strollerId: number, userId: number): UserStrollerConnectionCreateRequestAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_REQUEST, strollerId, userId,
    }),
    success: (strollerId: number, userId: number, response: UserStrollerConnectionCreateNormalizedResponse): UserStrollerConnectionCreateSuccessAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_SUCCESS, strollerId, userId, response,
    }),
    failure: (strollerId: number, userId: number, error: any): UserStrollerConnectionCreateFailureAction => ({
        type: USER_STROLLER_CONNECTION_CREATE_FAILURE, strollerId, userId, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Remove connection between user and stroller

export interface UserStrollerConnectionRemoveAction extends Action {
    readonly strollerId: number;
    readonly userId: number;
}

export const USER_STROLLER_CONNECTION_REMOVE_TRIGGER = 'USER_STROLLER_CONNECTION_REMOVE_TRIGGER';
export interface UserStrollerConnectionRemoveTriggerAction extends UserStrollerConnectionRemoveAction, Action {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_TRIGGER;
}
export const USER_STROLLER_CONNECTION_REMOVE_REQUEST = 'USER_STROLLER_CONNECTION_REMOVE_REQUEST';
export interface UserStrollerConnectionRemoveRequestAction extends UserStrollerConnectionRemoveAction, APIRequestAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_REQUEST;
}
export const USER_STROLLER_CONNECTION_REMOVE_SUCCESS = 'USER_STROLLER_CONNECTION_REMOVE_SUCCESS';
export interface UserStrollerConnectionRemoveSuccessAction extends UserStrollerConnectionRemoveAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_SUCCESS;
}
export const USER_STROLLER_CONNECTION_REMOVE_FAILURE = 'USER_STROLLER_CONNECTION_REMOVE_FAILURE';
export interface UserStrollerConnectionRemoveFailureAction extends UserStrollerConnectionRemoveAction, APIFailureAction {
    readonly type: typeof USER_STROLLER_CONNECTION_REMOVE_FAILURE;
}

export const userStrollersConnectionRemoveTrigger =
    (strollerId: number, userId: number): UserStrollerConnectionRemoveTriggerAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_TRIGGER, strollerId, userId,
    });
export const userStrollersConnectionRemoveActions = {
    request: (strollerId: number, userId: number): UserStrollerConnectionRemoveRequestAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_REQUEST, strollerId, userId,
    }),
    success: (strollerId: number, userId: number): UserStrollerConnectionRemoveSuccessAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_SUCCESS, strollerId, userId,
    }),
    failure: (strollerId: number, userId: number, error: any): UserStrollerConnectionRemoveFailureAction => ({
        type: USER_STROLLER_CONNECTION_REMOVE_FAILURE, strollerId, userId, error,
    }),
};
